(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sj-mobile-pack-list"]) return;
  try {
    
  (() => {
    const activateMobilePackList = () => {
      if (window.innerWidth > 749) return;
      if (!document.querySelector('.sj-mobile-pack-list-loader')) return;

      const roots = document.querySelectorAll('.sj9-variants.sj9-variants--collection');
      if (!roots.length) return;

      roots.forEach((root) => {
        if (root.dataset.mobilePackListBound === 'true') return;

        const grid = root.querySelector('.sj9-variants__grid');
        const catalog = root.querySelector('.sj9-variants__catalog-main');
        const sizeButtons = Array.from(root.querySelectorAll('[data-size-filter]'));
        if (!grid || !catalog || !sizeButtons.length) return;
        if (!grid.querySelector('.sj9-variant-card--kashi-pack')) return;

        root.dataset.mobilePackListBound = 'true';
        document.documentElement.classList.add('sj-mobile-pack-list-active');
        const flow = document.createElement('section');
        flow.className = 'sj9-mobile-pack-flow';
        catalog.appendChild(flow);

        const getSourceCard = (size) => Array.from(grid.querySelectorAll('.sj9-variant-card--kashi-pack')).find((card) => card.dataset.variantSize === size);
        const getActiveSize = () => root.querySelector('[data-size-filter].is-active')?.dataset.sizeFilter || sizeButtons.find((button) => button.dataset.sizeFilter !== 'all')?.dataset.sizeFilter;

        const selectPackAndAdd = (card, option) => {
          if (option) option.click();
          window.setTimeout(() => card.querySelector('[data-card-add-button], .sj9-variant-card__button')?.click(), 0);
        };

        const render = () => {
          const size = getActiveSize();
          const card = getSourceCard(size);
          if (!card) {
            flow.replaceChildren();
            return;
          }

          const heading = document.createElement('h3');
          heading.className = 'sj9-mobile-pack-flow__heading';
          heading.textContent = card.querySelector('.sj9-variant-card__pack-label')?.textContent?.trim() || '';
          const sizeLabel = document.createElement('p');
          sizeLabel.className = 'sj9-mobile-pack-flow__size';
          sizeLabel.textContent = card.querySelector('.sj9-variant-card__details h3')?.textContent?.trim() || '';
          const rows = document.createElement('div');
          rows.className = 'sj9-mobile-pack-flow__rows';
          const sourceImage = card.querySelector('.sj9-variant-card__media img');
          const sourceOptions = Array.from(card.querySelectorAll('[data-kashi-pack-option]'));
          const fallback = sourceOptions.length ? sourceOptions : [null];

          fallback.forEach((option, index) => {
            const row = document.createElement('article');
            row.className = 'sj9-mobile-pack-row';
            const packText = option?.textContent?.trim() || sizeLabel.textContent;
            if (/3/.test(packText)) row.classList.add('sj9-mobile-pack-row--best');

            const image = document.createElement('div');
            image.className = 'sj9-mobile-pack-row__image';
            if (sourceImage) image.appendChild(sourceImage.cloneNode(true));

            const content = document.createElement('div');
            content.className = 'sj9-mobile-pack-row__content';
            const title = document.createElement('span');
            title.className = 'sj9-mobile-pack-row__title';
            title.textContent = packText;
            const price = document.createElement('span');
            price.className = 'sj9-mobile-pack-row__price';
            price.textContent = option?.dataset.price || card.querySelector('[data-card-price], .sj9-variant-card__price strong')?.textContent?.trim() || '';
            content.append(title, price);
            const add = document.createElement('button');
            add.type = 'button';
            add.className = 'sj9-mobile-pack-row__add';
            add.textContent = card.dataset.addLabel || card.querySelector('.sj9-variant-card__button')?.textContent?.trim() || 'Add';
            const available = option ? option.dataset.available === 'true' : card.dataset.variantAvailable === 'true';
            add.disabled = !available;
            add.addEventListener('click', () => selectPackAndAdd(card, option));
            row.append(image, content, add);
            rows.appendChild(row);
          });

          flow.replaceChildren(heading, sizeLabel, rows);
        };

        root.addEventListener('click', (event) => {
          const button = event.target.closest('[data-size-filter]');
          if (!button || button.dataset.sizeFilter === 'all') return;
          window.requestAnimationFrame(render);
        });

        const firstSize = sizeButtons.find((button) => button.dataset.sizeFilter !== 'all');
        if (root.querySelector('[data-size-filter].is-active')?.dataset.sizeFilter === 'all' && firstSize) firstSize.click();
        render();
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', activateMobilePackList, { once: true });
    else activateMobilePackList();
  })();

  } catch(e) { console.error(e); }
})();
})();
